import { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const OrderingContext = createContext({
  takeout_enabled: true,
  delivery_enabled: true,
  delivery_url: '',
  disabled_message_fr: '',
  disabled_message_en: '',
  refresh: () => {},
});

export function OrderingProvider({ children }) {
  const [s, setS] = useState({
    takeout_enabled: true,
    delivery_enabled: true,
    delivery_url: 'https://www.skipthedishes.com/belgio-resto-et-traiteur',
    disabled_message_fr: '',
    disabled_message_en: '',
  });

  const refresh = () => {
    axios.get(`${API}/settings/ordering`).then(r => setS(r.data)).catch(() => {});
  };

  useEffect(() => { refresh(); }, []);

  return (
    <OrderingContext.Provider value={{ ...s, refresh }}>
      {children}
    </OrderingContext.Provider>
  );
}

export function useOrdering() {
  return useContext(OrderingContext);
}
